import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar, FunctionField } from 'react-admin';
import { Box, Breadcrumbs, Link, Typography, Chip } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const CustomerTypeListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const ConfigurationBreadcrumbs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/configuration')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Configuration
        </Link>
        <Typography color="text.primary">Customer Types</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const CustomerTypeList = () => {
  const navigate = useNavigate();

  return (
    <List
      title="Customer Types"
      actions={<CustomerTypeListActions />}
      filters={[]}
      empty={
        <CustomEmptyState
          resource="customer-types"
          onAction={() => navigate('/crm/customer-types/create')}
        />
      }
    >
      <ConfigurationBreadcrumbs />
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="description" />
        <FunctionField
          label="Color"
          render={(record: { color?: string }) => (
            <Chip
              label={record.color || '#1C5195'}
              size="small"
              sx={{
                bgcolor: record.color || '#1C5195',
                color: 'white',
                fontWeight: 'bold',
              }}
            />
          )}
        />
      </Datagrid>
    </List>
  );
};
